import React from 'react';
import HybridAssessmentRenderer from './HybridAssessmentRenderer';
import SkillAssessmentRenderer from './SkillAssessmentRenderer';
import InterviewEffectivenessRenderer from './InterviewEffectivenessRenderer';

const HybridRendererSelector = ({ assessmentData, type = 'skills', useStructured = true }) => {
  if (!assessmentData) return null;
  
  // Parse the response if needed
  let parsedData;
  try {
    parsedData = typeof assessmentData === 'string' 
      ? JSON.parse(assessmentData) 
      : assessmentData;
  } catch (error) {
    // If parsing fails, use as-is
    parsedData = assessmentData;
    useStructured = false;
  }
  
  // Check if we have structured data
  if (parsedData && parsedData.structured && useStructured) {
    if (type === 'skills') {
      return <SkillAssessmentRenderer assessmentData={parsedData.structured} />;
    } else if (type === 'effectiveness') {
      return <InterviewEffectivenessRenderer effectivenessData={parsedData.structured} />;
    }
  }
  
  // Fallback to the hybrid renderer
  return <HybridAssessmentRenderer evaluationResult={assessmentData} />;
};

export default HybridRendererSelector;